import LogRocket from 'logrocket'
import { getRecordingURL } from '@/utils/logrocketInit'

const INFRA_EVENTS_FOR_TRACK = new Set([
  '[infra:retry-attempt]',
  '[infra:retry-exhausted]',
  '[infra:retry-success]',
  '[infra:network-error]',
])

const INFRA_EVENTS_FOR_CAPTURE = new Set([
  '[infra:retry-exhausted]',
  '[infra:network-error]',
])

export type InfraPayload = Record<string, string | number | boolean>

export type LogInfraOptions = {
  capture?: boolean,
  track?: boolean,
}

export const sanitizeUrl = (rawUrl: string | undefined): string => {
  if (!rawUrl) return ''
  const queryIdx = rawUrl.indexOf('?')
  return queryIdx === -1 ? rawUrl : rawUrl.slice(0, queryIdx)
}

const toTrackName = (event: string): string =>
  event.replace(/^\[|]$/g, '').replace(/:/g, '_').replace(/-/g, '_')

export const logInfra = (
  event: string,
  payload: InfraPayload,
  options: LogInfraOptions = {},
): void => {
  if (!['production', 'staging'].includes(import.meta.env.VITE_APP_ENV)) return

  const enriched: InfraPayload = {
    ...payload,
    recordingURLReady: Boolean(getRecordingURL()),
  }

  LogRocket.log(event, enriched)

  const trackAllowed = options.track !== false
  if (trackAllowed && INFRA_EVENTS_FOR_TRACK.has(event)) {
    LogRocket.track(toTrackName(event), enriched)
  }

  const captureAllowed = options.capture !== false
  if (captureAllowed && INFRA_EVENTS_FOR_CAPTURE.has(event)) {
    LogRocket.captureMessage(event, { extra: enriched })
  }
}
